import React, { useState, useEffect, Fragment } from 'react';
import SubscriptionContainer from '../../../Backend/Pages/Ecommerce/CustomerModule/SubscriptionContainer';

const MyPageSubscriptionEdit = (props) => {    

    return (<Fragment>
        <SubscriptionContainer customerId={props.customerId} refresh={() => props.refreshExistingSubscription()}
            subscriptionToEdit={props.subscriptionToEdit} hideAddSubscription={() => props.hideEdit()} mypages={true}>
        </SubscriptionContainer>
    </Fragment>)
}

export default MyPageSubscriptionEdit;